import { z } from "zod"

export const invoiceSettingsFormDefaultValues = {
  electricity_rate: "",
  default_invoice_memo: "",
}

export const InvoiceSettingsSchema = z.object({
  electricity_rate: z.string().optional(),
  default_invoice_memo: z.string().optional(),
})

export type InvoiceSettingsType = z.infer<typeof InvoiceSettingsSchema>
